import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PortalAddressPipe } from './address/address.pipe';
import { BooleanPipe } from './boolean.pipe';
import { PortalCurrencyPipe } from './currency/currency.pipe';
import { CurrencySymbolPipe } from './currency-symbol/currency-symbol.pipe';
import { PortalFullNamePipe } from './full-name/full-name.pipe';
import { HumanBooleanPipe } from './human-boolean.pipe';
import { PortalLangPipe } from './lang.pipe';
import { LogisticCompanyPipe } from './logistic-company.pipe';
import { MemoizePipe } from './memoize.pipe';
import { MultiLangPipe } from './multilang.pipe';
import { ObjectIsEmptyPipe } from './object-is-empty.pipe';
import { OrderFinalStatusPipe } from './order-final-status.pipe';
import { OrderStatusI18nPipe } from './order-status-i18n.pipe';
import { OrderStatusPreTranslatePipe } from './order-status-pretranslate.pipe';
import { OrderStatusPipe } from './order-status.pipe';
import { PhoneNumberPipe } from './phone-number.pipe';
import { PricePerItemPipe } from './price-per-item.pipe';
import { PortalProfilePipe } from './profile.pipe';
import { RemoveHtmlTagsPipe } from './remove-html-tags.pipe';
import { SafePipe } from './safe.pipe';
import { SearchPipe } from './search.pipe';
import { SortPipe } from './sort.pipe';
import { PortalTemplateCellPipe } from './template-cell.pipe';
import { TextCutPipe } from './text-cut.pipe';
import { UnitedOrderPipe } from './united-order.pipe';

const pipes = [
  PortalAddressPipe,
  SortPipe,
  SafePipe,
  SearchPipe,
  PortalCurrencyPipe,
  OrderStatusI18nPipe,
  OrderStatusPipe,
  CurrencySymbolPipe,
  MemoizePipe,
  MultiLangPipe,
  TextCutPipe,
  PortalLangPipe,
  OrderFinalStatusPipe,
  BooleanPipe,
  HumanBooleanPipe,
  PortalTemplateCellPipe,
  PortalFullNamePipe,
  PricePerItemPipe,
  UnitedOrderPipe,
  ObjectIsEmptyPipe,
  OrderStatusPreTranslatePipe,
  PhoneNumberPipe,
  RemoveHtmlTagsPipe,
  PortalProfilePipe,
  LogisticCompanyPipe,
];

@NgModule({
  imports: [CommonModule],
  declarations: pipes,
  exports: pipes,
})
export class PipesModule {}
